import React, { useContext } from 'react';

import { SiteNavigation } from '@motorway/mw-dealer-shared-components/components';

import { FeaturesContext } from 'Context/FeaturesContext/FeaturesContext';
import { useDealerDashboard } from 'Utilities/hooks/useDealerDashboard';
import useUser from 'Utilities/hooks/useUser';

import { usePageComposerSiteNavigation } from './hooks/usePageComposerSiteNavigation';

export const PageComposerSiteNavigation: React.FC = () => {
	const features = useContext(FeaturesContext);
	const { isDealerDashboardEnabled } = useDealerDashboard();
	const user = useUser();
	const updatedFeatures = {
		...features,

		// TODO: Remove these values once the feature toggles have been removed from DSC / Optimizely
		accountSettings: true,
		dealerDashboard: isDealerDashboardEnabled,
		tradeExperience: true,
		tradeNavigation: true,
	};

	const { activeItemId, handlers, hasBottomBorder, isHidden, isSticky, isTransparent, permissions } =
		usePageComposerSiteNavigation();

	if (isHidden) {
		return null;
	}

	return (
		<SiteNavigation
			activeItemId={activeItemId}
			dataAttributes={{}}
			features={updatedFeatures}
			handlers={handlers}
			hasBottomBorder={hasBottomBorder}
			isSticky={isSticky}
			isTransparent={isTransparent}
			permissions={permissions}
			user={user}
		/>
	);
};
